import { render } from "./play.svg?vue&type=template&id=5338e31e"
const script = {}
script.render = render

export default script